import type { TranslationMessages } from './types';

// Basic Vietnamese messages (simplified)
const vietnameseMessages: TranslationMessages = {
  ra: {
    action: {
      add: 'Thêm',
      back: 'Quay lại',
      cancel: 'Hủy',
      create: 'Tạo',
      delete: 'Xóa',
      edit: 'Sửa',
      export: 'Xuất',
      list: 'Danh sách',
      refresh: 'Làm mới',
      save: 'Lưu',
      search: 'Tìm kiếm',
      show: 'Xem',
    },
    auth: {
      logout: 'Đăng xuất',
      username: 'Tên đăng nhập',
      password: 'Mật khẩu',
      sign_in: 'Đăng nhập',
    },
    navigation: {
      no_results: 'Không có kết quả',
      no_more_results:
        'Số trang %{page} vượt quá giới hạn. Hãy thử trang trước.',
      page_out_of_boundaries: 'Số trang %{page} vượt quá giới hạn',
      page_out_from_end: 'Không thể đi qua trang cuối',
      page_out_from_start: 'Không thể đi trước trang 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} của %{total}',
      page_rows_per_page: 'Số hàng mỗi trang:',
      next: 'Sau',
      prev: 'Trước',
    },
    page: {
      dashboard: 'Bảng điều khiển',
      not_found: 'Không tìm thấy',
      loading: 'Đang tải',
    },
  },
};

// Import separate Vietnamese translation files
import { common } from './common.vi';
import { pos } from './pos.vi/index';
import { notifications } from './notifications.vi';
import { richTextUltra } from './richTextUltra.vi';
import { bugReport } from './bugReport.vi';
import { support } from './support.vi';
import { faq } from './faq.vi';
import { assistant } from './assistant.vi';
import { version } from './version.vi';

// Combine all Vietnamese translations
const customVietnameseMessages: TranslationMessages = {
  ...vietnameseMessages,
  common,
  pos,
  notifications,
  richTextUltra,
  bugReport,
  support,
  faq,
  assistant,
  version,
};

export default customVietnameseMessages;
